import React from "react";
import { Field } from "../component";
import { Form } from "react-bootstrap";
import { get } from "lodash";
import { isValidArray } from "../helper";

export default function({
  type = "text",
  className = "",
  value = "",
  requiredClass = "",
  label = "",
  isRequired = false,
  key = "",
  onChange = () => {},
  onError = () => {},
  error = {},
  options = [],
  displayError = true,
  isDisabled = false,
  classSecondary = "",
  onBlur = value => {}
}) {
  return (
    <React.Fragment>
      <Form.Group>
        {(label && (
          <Form.Label className={classSecondary}>
            {label}
            {isRequired && <span className={requiredClass}>*</span>}
          </Form.Label>
        )) ||
          null}
        <div className="form-field">
          <Field
            as={type}
            keyName={key}
            onChange={onChange}
            onError={onError}
            value={value}
            isInvalid={get(error, `error`)}
            className={className}
            disabled={isDisabled}
            onBlur={onBlur}
          >
            <option value="">- Select {label} -</option>
            {isValidArray(options)
              ? options.map(value => {
                  return <option value={value.id}>{value.name}</option>;
                })
              : null}
          </Field>
          {(displayError && (
            <Form.Control.Feedback type="invalid">
              {get(error, `message`)}
            </Form.Control.Feedback>
          )) ||
            null}
        </div>
      </Form.Group>
    </React.Fragment>
  );
}
